import { SiteMetricBenchmark, SiteMetricDetail, SiteMetricSummary, SiteMilestone } from '../../scripts/site-activation.entities';
import { SiteActivationLookup } from '../../scripts/site-activation.lookup';
import { DashboardCard, SiteCardData } from '../dashboard-card/dashboard-card';

export class MilestoneDashboardTab {

    siteMetricDetails: SiteMetricDetail[];

    cardData: Map<string, SiteCardData>;
    filteredKeys: string[];
    dashboardTab: HTMLElement;

    studyIds: number[];
    metricIds: number[];
    inPlayId: number;
    platformTrialMap: Map<string, string[]>;
    filteredTrials: string[];
    filteredTrialsMap: Map<string, string>;
    showAbsolute = true;

    constructor(siteMetricSummaries: SiteMetricSummary[], siteMetricDetails: SiteMetricDetail[], siteMetricBenchmarks: SiteMetricBenchmark[]) {
        this.siteMetricDetails = siteMetricDetails;
        window.customElements.define("dashboard-card", DashboardCard);

        this.dashboardTab = document.querySelector('#dashboardTab');

        this.platformTrialMap = new Map();
        this.platformTrialMap.set('AUTONOMIC', ['IVIG', 'Ivabradine', 'Combined']);
        this.platformTrialMap.set('ENERGIZE', ['Cardiopulmonary Rehab', 'Structured Pacing', 'Combined']);
        this.platformTrialMap.set('NEURO', ['tDCS &  BrainHQ', '', 'Combined']);
        this.platformTrialMap.set('SLEEP', ['Modafinil/Solriamfetol', 'Melatonin/Light', 'Combined']);
        this.platformTrialMap.set('VITAL', ['Paxlovid', '', 'Combined']);

        this.filteredTrialsMap = new Map();
        this.filteredTrialsMap.set("AUTONOMIC (Combined)", "5-1-1");
        this.filteredTrialsMap.set("AUTONOMIC (IVIG)", "5-1-0");
        this.filteredTrialsMap.set("AUTONOMIC (Ivabradine)", "5-0-1");
        this.filteredTrialsMap.set("ENERGIZE (Combined)", "6-1-1");
        this.filteredTrialsMap.set("ENERGIZE (Cardiopulmonary Rehab)", "6-1-0");
        this.filteredTrialsMap.set("ENERGIZE (Structured Pacing)", "6-0-1");
        this.filteredTrialsMap.set("NEURO (Combined)", "3-1-1");
        this.filteredTrialsMap.set("NEURO (tDCS & BrainHQ)", "3-1-0");
        this.filteredTrialsMap.set("SLEEP (Combined)", "4-1-1");
        this.filteredTrialsMap.set("SLEEP (Modafinil/Solriamfetol)", "4-1-0");
        this.filteredTrialsMap.set("SLEEP (Melatonin/Light)", "4-0-1");
        this.filteredTrialsMap.set("VITAL (Combined)", "2-1-1");
        this.filteredTrialsMap.set("VITAL (Paxlovid)", "2-1-0");


        this.cardData = new Map();

        siteMetricSummaries.forEach((summary) => {
            //const key = `${summary.StudyId}-${summary.MetricId}-${summary.InPlayId}`;
            const key = `${summary.StudyId}-${summary.MetricId}-${summary.InPlayId}-${summary.AppendixA}-${summary.AppendixB}`;

            const cd = this.cardData.get(key);


            if (cd) {
                if (summary.CompletedId === 0) {
                    cd.inProgress = summary;
                } else {
                    cd.completed = summary;
                }
            } else {
                let trial = "";

                trial = this.platformTrialMap.get(SiteActivationLookup.GetPrimeContract(summary.StudyId))[(summary.AppendixA + (summary.AppendixB*2))-1]
                //if (summary.AppendixA == 1 && summary.AppendixB == 1) {
                //    trial = "Combined";
                //}
                //else if (summary.AppendixA == 1) {
                //    trial = "Appendix A";
                //}
                //else if (summary.AppendixB == 1) {
                //    trial = "Appendix B";
                //}
                const benchmark = siteMetricBenchmarks.find((b) => ((b.StudyId === summary.StudyId) && (b.MetricId === summary.MetricId)));

                const scd = {
                    studyId: summary.StudyId,
                    studyName: '',
                    metricId: summary.MetricId,
                    metricName: '',
                    inPlayId: summary.InPlayId,
                    orderBy: summary.OrderBy,
                    yellowDays: benchmark?.YellowDays,
                    redDays: benchmark?.RedDays,
                    trial: trial,
                    appendixA: summary.AppendixA,
                    appendixB: summary.AppendixB,
                } as SiteCardData;

                scd.studyName = SiteActivationLookup.GetPrimeContract(summary.StudyId);
                scd.metricName = SiteActivationLookup.GetMetric(summary.MetricId);

                if (summary.CompletedId === 0) {
                    scd.inProgress = summary;

                    // TODO Temporary hack for "N/A" style metrics
                    if (summary.MetricId === 16) {
                        scd.completed = {
                            NumberOfSites: 0,
                            MeanValue: 0,
                            MinValue: 0,
                            Q1Value: 0,
                            MedianValue: 0,
                            Q3Value: 0,
                            MaxValue: 0,
                        } as SiteMetricSummary;
                    }
                } else {
                    scd.completed = summary;
                }

                this.cardData.set(key, scd);
            }
        });

        this.cardData.forEach((cd) => {

            const droppedValue = cd.inPlayId - 1;

            const filtered = this.siteMetricDetails.filter((site) => (
                (site.StudyId === cd.studyId) &&
                (site.MetricId === cd.metricId) &&
                (site.Days !== "") &&
                (site.AppendixA === cd.appendixA) &&
                (site.AppendixB === cd.appendixB)
                ));

            cd.sites = (droppedValue === -1) ? filtered : filtered.filter((site) => site.Dropped === droppedValue);

        });

        (document.querySelector('#proportionalCheckbox') as HTMLInputElement).checked = this.showAbsolute
        document.querySelector('#proportionalCheckbox').addEventListener('click', (e) => {
            const cb = e.target as any;
            this.showAbsolute = cb.checked;

            this.filter();
        });

    }

    filter() {
        this.filteredKeys = [];

        if (this.inPlayId !== -1) {
            this.metricIds.forEach((mid) => this.studyIds.forEach((sid) => {
                if ((mid === 10) && (sid === 3)) return; // NEURO doesn't have IP Sent metric
                // Only add key if the data exists
                if (this.cardData.has(`${sid}-${mid}-${this.inPlayId}-1-0`)) {
                    this.filteredKeys.push(`${sid}-${mid}-${this.inPlayId}-1-0`);
                }
                if (this.cardData.has(`${sid}-${mid}-${this.inPlayId}-0-1`)) {
                    this.filteredKeys.push(`${sid}-${mid}-${this.inPlayId}-0-1`);
                }
                if (this.cardData.has(`${sid}-${mid}-${this.inPlayId}-1-1`)) {
                    this.filteredKeys.push(`${sid}-${mid}-${this.inPlayId}-1-1`);
                }
            }));
        }

        this.dashboardTab.innerHTML = '';
        const maxSites = Math.max(...this.filteredKeys.map((key) => {
            return (this.cardData.get(key).inProgress?.NumberOfSites);
            }));
        const maxDays = Math.max(...this.filteredKeys.map((key) => {
            const cd = this.cardData.get(key);
            return Math.max(cd.inProgress.MaxValue, cd.completed?.MaxValue);
        }));
        const minDays = Math.min(...this.filteredKeys.map((key) => {
            const cd = this.cardData.get(key);
            return Math.min(cd.inProgress.MinValue, cd.completed?.MinValue);
        }));

        this.filteredKeys.forEach((key) => {

            let ids = key.split('-');
            let studyAppendix = ids[0] + "-" + ids[3] + "-" + ids[4];
            if (this.filteredTrials.includes(studyAppendix)) { 
                const card = document.createElement('dashboard-card') as DashboardCard;
                const data = this.cardData.get(key);
                card.setData(
                    data,
                    (this.showAbsolute) ? maxSites : undefined,
                    (this.showAbsolute) ? maxDays : undefined,
                    (this.showAbsolute) ? minDays : undefined
                );

                this.dashboardTab.appendChild(card);
            }
        });
    }

    updateContent(studies, metrics, inPlayIds, filteredTrials) {
        this.studyIds = studies.map((value) => ['', '', 'VITAL', 'NEURO', 'SLEEP', 'AUTONOMIC', 'ENERGIZE'].indexOf(value)).sort((a, b) => a - b);

        this.filteredTrials = filteredTrials.map((value) => this.filteredTrialsMap.get(value));
        this.metricIds = metrics.map((id) => Number.parseInt(id));

        if (inPlayIds.length <= 0) this.inPlayId = -1;
        else if (inPlayIds.length >= 2) this.inPlayId = 0; //All
        else if (inPlayIds[0] === 'No') this.inPlayId = 2; //Not In Play
        else this.inPlayId = 1; //In Play

        this.filter();
    }

    showModal(siteId: number, studyId: number, metricId: number, milestones: SiteMilestone[], appendixA: number, appendixB: number) {
        const s = this.siteMetricDetails.find((site) => (
            (site.SiteId === siteId) &&
            (site.StudyId === studyId) &&
            (site.MetricId === metricId) &&
            (site.AppendixA === appendixA) &&
            (site.AppendixB === appendixB)
        ) );
        $('#dashboardSiteModal').modal('show');
        document.querySelector('#dashboardSiteModalLabel').innerHTML = `${s.SiteName} (${s.SiteIdDisplay})`;

        const milestoneRow = milestones.map((milestone) => {
            return `
            <tr>
                <td>${milestone.Milestone}</td>
                <td>${milestone.DateCompletion}</td>
                <td>${milestone.CommentDisplay}</td>
            </tr>
            `;

        });
        document.querySelector('.dashboard-modal-body').innerHTML = `
            <table class="table table-striped w-100">
                <thead>
                    <tr>
                        <th>Milestone</th>
                        <th>Completion Date</th>
                        <th>Comment</th>
                    </tr>
                </thead>
                <tbody>
                    ${milestoneRow.join('')}
                </tbody>
            </table>
        `;
    }
}